import React from 'react';
import PropTypes from 'prop-types';
import { extractYoutubeID } from '../utils/helpers';

const LandingHeroVideo = ({ heroSection, history, showButtons }) => (
  <div className={`bg-img row row align-items-center p-0 px-md-5 ${heroSection.className}`} style={{ minHeight: '450px', backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url("${heroSection.backgroundImgURL}")` }} alt='hero image' data-cy='hero-img'>
    <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 p-0 px-lg-0 p-lg-5 d-flex flex-column flex-lg-row align-items-center'>
      <div className='col-12 col-lg-6 px-2 px-sm-5 px-md-0 pt-lg-0'>
        <iframe
          width='100%'
          height='300'
          style={{ margin: '0 auto', display: 'block' }}
          src={`https://www.youtube.com/embed/${extractYoutubeID(heroSection.youtubeLink)}`}
          frameBorder='0'
          data-cy='landing-hero-video'
          allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen />
      </div>
      <div className='col-12 px-5 px-md-0 pt-5 pt-lg-0 col-lg-6 ps-0 ps-lg-5'>
        <div className='row align-content-center'>
          <div className='col-12'>
            <h1>{heroSection.title}</h1>
          </div>
          <div className='col-12 my-3' >{heroSection.description}</div>
          <div className='col-12 text-left pb-5 pb-lg-0'>
            {showButtons &&
                <div>
                  <button className='btn btn-primary mb-3 me-3' data-cy='hero-prescreen' onClick={() => history.push({ pathname: '/register' })}>{heroSection.btn1_text}</button>
                  <button className='btn btn-outline-primary mb-3' data-cy='hero-required-docs' onClick={() => history.push({ pathname: '/required-documents' })}>{heroSection.btn2_text}</button>
                </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
);

LandingHeroVideo.propTypes = {
  heroSection: PropTypes.object,
  history: PropTypes.object,
  showButtons: PropTypes.bool,
};

export default LandingHeroVideo;
